// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';

export const PartiesContext = React.createContext<PartiesState>({
  operator: '',
  party: '',
  dso: '',
});

type PartiesState = {
  operator: string;
  party: string;
  dso: string;
};

/**
 * @deprecated prefer either useModuleParty, useDsoParty, or useOperatorParty hooks directly
 */
export const useParties: () => PartiesState = () => {
  return useContext<PartiesState>(PartiesContext);
};
